import * as React from 'react';

import type { ProfilePage } from 'schema-dts';

import GoogleMarkup from 'bundles/seo/components/GoogleMarkup';
import type { AuthorProfile } from 'bundles/shared-articles/components/ArticleAuthorProfile';
import {
  createAuthorSchema,
  createGraph,
  createWebsiteSchema,
} from 'bundles/shared-articles/components/seo/utils/schemaMarkupUtils';

type Props = {
  author: AuthorProfile;
  id: string;
};

const AuthorPageGoogleSchemaMarkup = ({ author, id }: Props) => {
  if (!author?.name || !id) {
    return null;
  }

  const authorSchema = createAuthorSchema(author);

  const pageSchema: ProfilePage = {
    '@type': 'ProfilePage',
    '@id': `${id}#webpage`,
    inLanguage: 'en-US',
    url: id,
    mainEntity: {
      '@type': 'Person',
      name: author.name,
    },
    isPartOf: createWebsiteSchema(),
  };

  return (
    <div data-testid="AuthorPageGoogleSchemaMarkup">
      <GoogleMarkup graph={createGraph([authorSchema, pageSchema])} />
    </div>
  );
};

export default AuthorPageGoogleSchemaMarkup;
